import React from "react";
import Navbar from "./global-components/navbar";
import Footer from "./global-components/footer";
import AboutV1 from "./section-components/aboutv1";

const Aboutt = () => {
  return (
    <div>
      <Navbar />

      <div style={{ marginTop: "100px" }}>
        <AboutV1 />
      </div>

      <Footer />
    </div>
  );
};

export default Aboutt;